"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFormattedDate = void 0;
var moment_1 = __importDefault(require("moment"));
var getDaysDiff_1 = require("./getDaysDiff");
var createFormattedDate = function (inputDate, altDate, prefix, options) {
    if (altDate === void 0) { altDate = null; }
    if (prefix === void 0) { prefix = null; }
    if (options === void 0) { options = {}; }
    //alt date is only to deal with the blunder of not saving published date sometime back
    var _a = options.switchDisplayFormatAfter, switchDisplayFormatAfter = _a === void 0 ? 1 : _a, _b = options.format, format = _b === void 0 ? "DD MMM YYYY" : _b;
    if (!inputDate && !altDate)
        return null;
    var inputMoment = inputDate ? (0, moment_1.default)(inputDate) : (0, moment_1.default)(altDate);
    var daysDiff = inputDate
        ? (0, getDaysDiff_1.getDaysDiff)(inputDate).count
        : (0, getDaysDiff_1.getDaysDiff)(altDate).count;
    var toReturn;
    if (Math.abs(daysDiff) > switchDisplayFormatAfter) {
        toReturn = "".concat(prefix ? prefix : "", " ").concat(inputMoment.format(format));
    }
    else {
        toReturn = inputMoment.fromNow();
    }
    return toReturn;
};
exports.createFormattedDate = createFormattedDate;
